// extracted by mini-css-extract-plugin
export default {"dialogBox-outer":"ForgotPasswordEmail_dialogBox-outer__aUF9l","dialog-title":"ForgotPasswordEmail_dialog-title__rD+jb","backgroundblur":"ForgotPasswordEmail_backgroundblur__3-Kgb"};